import React from 'react'

import closeBtn from './../../../UI/general/close.svg'

interface Props{
    isFormularioOpened: boolean,
    handleOpenFormulario: any,
    selectedBike: any
}

interface State{
}

class Form extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isFormularioOpened ? 'form fade-in':'form fade-out'}>
                <div className='gallery-bar-header'>
                    <div className='gallery-bar-title'>
                        FORMULARIO
                    </div>
                    <img className='close-btn-gallery' src={closeBtn} onClick = {() => {this.props.handleOpenFormulario(false)}}/>
                </div>
                <div className='form-container'>
                    <div className="form-nombre-container">
                        <div>Nombre Completo</div>
                        <input type="text" placeholder="Nombre y Apellido" className="nombre-input" required /*onChange={e => this.props.handleChangeName(e)}*//> 
                    </div>
                    <div className="form-mobile-container">
                        <div>Teléfono</div>
                        <input type="number" placeholder="Celular" className="input" required /*onChange={e => this.props.handleChangePhone(e)}*//> 
                    </div>
                    <div className="email-mobile-container">
                        <div>Correo electronico</div>
                        <input type="email" placeholder="Correo Electronico" className="input" required /*onChange={e => this.props.handleChangeEmail(e)}*//>
                    </div>
                    <div className='legal-text'>Al aceptar autorizas el tratamiento de datos personales en los términos descritos. </div>
                    <a className='enviar-btn' href=''>

                    </a>
                </div>
            </div>
        )
    }
}

export default Form